<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
    width="50%"
    @close="onBeforeClose"
  >
    <el-form ref="form" label-position="top" :model="form" :rules="rules">
      <el-form-item label="账号名称">
        <el-input v-model="form.user" disabled></el-input>
      </el-form-item>
      <el-form-item label="原密码" prop="pass">
        <el-input type="password" maxlength="20" v-model="form.pass"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newpass">
        <el-input type="password" maxlength="20" v-model="form.newpass"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="newpass2">
        <el-input type="password" maxlength="20" v-model="form.newpass2"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="$emit('input', false)">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import store from '@/store'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.form.newpass2 !== '') {
          this.$refs.form.validateField('newpass2')
        }
        callback()
      }
    }
    var validateNewPass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newpass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      form: {
        user: store.state.global.user,
        pass: '',
        newpass: '',
        newpass2: ''
      },
      rules: {
        pass: [
          { required: true, message: '请输入原密码' },
          { min: 6, max: 20, message: '密码长度在6~20位' }
        ],
        newpass: [
          { validator: validateNewPass },
          { min: 6, max: 20, message: '密码长度在6~20位' },
          { required: true, message: '请输入新密码' }
        ],
        newpass2: [
          { validator: validateNewPass2 },
          { min: 6, max: 20, message: '密码长度在6~20位' },
          { required: true, message: '请输入确认密码' }
        ]
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
    }
  },
  methods: {
    onBeforeClose () {
      this.$refs.form.resetFields()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http.post('/changepass/submit2', this.form)
            .then(res => {
              if (res.successful) {
                this.$emit('input', false)
                this.$message.success('更改密码成功')
              } else {
                this.$message.error('更改密码失败')
              }
            })
        }
      })
    }
  }
}
</script>
